import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import "./rtl.css"; // RTL styles for Arabic
import "./i18n"; // Initialize i18next
import App from "@/App";
import CookiePolicy from "@/pages/CookiePolicy";
import TermsOfService from "@/pages/TermsOfService";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import LanguageRouteHandler from "@/components/LanguageRouteHandler";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <LanguageRouteHandler>
        <Routes>
        {/* Estonian (default) */}
        <Route path="/" element={<App />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        
        {/* Estonian (explicit route) */}
        <Route path="/et" element={<App />} />
        <Route path="/et/cookie-policy" element={<CookiePolicy />} />
        <Route path="/et/küpsiste-poliitika" element={<CookiePolicy />} />
        <Route path="/et/terms-of-service" element={<TermsOfService />} />
        <Route path="/et/kasutustingimused" element={<TermsOfService />} />
        <Route path="/et/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/et/privaatsuspoliitika" element={<PrivacyPolicy />} />
        
        {/* English */}
        <Route path="/en" element={<App />} />
        <Route path="/en/cookie-policy" element={<CookiePolicy />} />
        <Route path="/en/terms-of-service" element={<TermsOfService />} />
        <Route path="/en/privacy-policy" element={<PrivacyPolicy />} />
        
        {/* Russian */}
        <Route path="/ru" element={<App />} />
        <Route path="/ru/cookie-policy" element={<CookiePolicy />} />
        <Route path="/ru/terms-of-service" element={<TermsOfService />} />
        <Route path="/ru/privacy-policy" element={<PrivacyPolicy />} />
        
        {/* Arabic */}
        <Route path="/ar" element={<App />} />
        <Route path="/ar/cookie-policy" element={<CookiePolicy />} />
        <Route path="/ar/terms-of-service" element={<TermsOfService />} />
        <Route path="/ar/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
      </LanguageRouteHandler>
    </BrowserRouter>
  </React.StrictMode>,
);
